//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionObject.js";
let d=[[],[],[]];
SPLM.Motion.MotionSensor = class extends SPLM.Motion.MotionObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.MotionSensor";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;